var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}]},[_c('div',{ref:"resizableDiv"},[_vm._t("table",null,{"tableHeight":_vm.tableHeight})],2),_vm._v(" "),_vm._t("filter")],2)}
var staticRenderFns = []

export { render, staticRenderFns }